import React from 'react';  
import './index.css';
import { List } from 'antd-mobile';
import NoContent from 'component/noContent';
import ExcellentItem from 'component/excellentItem'
 
 
  

class InfoWorks extends React.Component{
  render(){
    const {data,title} =this.props;
    return (
      <List className="tab-works">
      {
        data&&data.size!=0?
        data.map((item,index)=>{
          return(<ExcellentItem key={index} index={index} data={item} title={title} />)
        }):
        <NoContent/>
      }
      </List>
      )
  }
}
export default InfoWorks;